import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import pc2 from '../images/pc2.png';
import three from '../images/3.png';


const Page4 = (rond) => {
  const navigate = useNavigate();
  const location = useLocation();
  const allResults = location.state.allResults;
  const { round } =  rond;
  
  
  return (
    <>
      
      <div className="text-xl text-center py-5">Round {round+1} Key Generation</div>
      <div className="flex items-center space-x-4 pt-40">
        <div className="flex flex-col space-y-4 pl-5">
          <p>Left 28 bits after shift</p>
          <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
            {allResults[round][1][0][0]}
            <br></br>
            {allResults[round][1][0][1]}
            <br></br>
            {allResults[round][1][0][2]}
            <br></br>
            {allResults[round][1][0][3]}
            <br></br>
          </div>
          <p>Right 28 bits after shift</p>
          <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
            {allResults[round][1][1][0]}
            <br></br>
            {allResults[round][1][1][1]}
            <br></br>
            {allResults[round][1][1][2]}
            <br></br>
            {allResults[round][1][1][3]}
            <br></br>
          </div>
        </div>

        <svg
          width="100"
          height="38"
          viewBox="0 0 573 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
            fill="black"
          />
        </svg>

        <div className="flex flex-col space-y-4">
          <p>56 Bits</p>
          <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
          {allResults[round][1][0][0]} {allResults[round][1][0][1]}
            <br></br>
            {allResults[round][1][0][2]} {allResults[round][1][0][3]}
            <br></br>
            {allResults[round][1][1][0]} {allResults[round][1][1][1]}
            <br></br>
            {allResults[round][1][1][2]} {allResults[round][1][1][3]}
            <br></br>
          </div>
        </div>
        <svg
          width="100"
          height="38"
          viewBox="0 0 573 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
            fill="black"
          />
        </svg>

        <div class="flex flex-col space-y-4">
          <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
          <p>Effective 48 Bit Key</p>
          <div class="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
            {allResults[round][2].slice(0, 12)}
            <br></br>
            {allResults[round][2].slice(12, 24)}
            <br></br>
            {allResults[round][2].slice(24, 36)}
            <br></br>
            {allResults[round][2].slice(36, 48)}
            <br></br>
          </div>
          <img src={pc2} alt="pc2" />
        </div>
        <img src={three} alt="three" width="250"  />
      </div>
    </>
  );
};

export default Page4;
